import { CategoryRegistry } from '@/features/pos/components/ProductCatalog/parts/CategoryBar/types'
import { RefObject, useRef } from 'react'

type Register = (id: string, hasSubcategories: boolean, index: number) => void

export const useCategoryRegistryRef = (): [RefObject<CategoryRegistry>, Register] => {
    const registryRef = useRef<CategoryRegistry>({})

    const register: Register = (id, hasSubcategories, index) => {
        registryRef.current[id] = { hasSubcategories, index }
    }

    return [registryRef, register]
}
